import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  CreateAreaMutation as CreateAreaMutationType,
  CreateAreaMutationVariables,
} from "./__generated__/CreateAreaMutation";

const CreateAreaMutation = loader("./CreateAreaMutation.gql");

type CreateAreaMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: CreateAreaMutationType) => void;
}) => ReactElement;

export const CreateAreaMutationProvider: CreateAreaMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<CreateAreaMutationType, CreateAreaMutationVariables>(CreateAreaMutation, {
    errorPolicy: "none",
    onError,
    onCompleted,
  });

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
